import React from "react";
import {translate} from "../../i18n/translate"
import styles from "../../css/common/footer.less";

class Footer extends React.Component {
    getCustomFooter = () => {
        return (
            <div dangerouslySetInnerHTML={{__html: this.props.staticData.customFooterHTML}}/>
        )
    };

    render() {
        return (
            <div className="footer">
                {(this.props.staticData.customFooterHTML && this.props.staticData.customFooterHTML !== '' && !this.props.clientViewPort.isXs) ?
                    this.getCustomFooter()
                    : undefined
                }
                <div className="footer-strip">
                    <div className="farmigo-footer">
                        <a href="http://www.farmigo.com" target="_new">
                            <div className="farmigo-text">{translate("Powered By")} </div>
                            <i className="farmigo-logo"/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js